import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';

const Education = () => {
  const { t } = useLanguage();
  usePageTitle('Education');

  return (
    <div className="-mt-16">
      {/* Hero: STEM MVP banner */}
      <section className="relative pt-44 sm:pt-48 md:pt-52 pb-8 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-mesh" />
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-gradient-to-br from-amber-600/12 via-orange-600/8 to-transparent rounded-full blur-[100px]" />
          <div className="absolute -bottom-20 -left-20 w-[500px] h-[500px] bg-gradient-to-tr from-blue-600/8 to-transparent rounded-full blur-[100px]" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-bold tracking-tight text-gradient-animated mb-0">
            <span className="block text-xl sm:text-2xl md:text-3xl">{t('education.mvpBanner')}</span>
            <a href="https://www.haohaoxuexi.ai" target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-lg sm:text-xl md:text-2xl text-accent font-semibold underline underline-offset-2 hover:text-accent-hover hover:no-underline transition-colors cursor-pointer">
              www.haohaoxuexi.ai
            </a>
          </h1>
        </div>
      </section>

      {/* Intro block (similar to Forum /info page) */}
      <section className="relative pt-8 pb-20 overflow-hidden">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-4 text-white flex items-center gap-2">
            <Sparkles className="h-6 w-6 sm:h-7 sm:w-7 text-accent flex-shrink-0" />
            {t('education.aiFeature.title')}
          </h2>
          <p className="text-base md:text-lg text-gray-400 leading-relaxed mb-8">
            {t('education.aiFeature.description')}
          </p>
          <div className="mx-auto max-w-xl rounded-xl overflow-hidden border border-dark-border bg-dark-card mb-8 shadow-lg">
            <img
              src="/images/education-ai-platform.png"
              alt={t('education.introImageAlt')}
              className="w-full h-auto object-contain bg-dark-surface"
            />
          </div>
          <Link
            to="/ai-education"
            className="inline-flex items-center gap-2 px-5 py-2.5 text-accent font-medium text-sm rounded-full border border-accent/30 hover:bg-accent/10 transition-all duration-300"
          >
            {t('education.aiFeature.cta')} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Education;
